import { Component, OnInit, ViewEncapsulation, Input, HostListener, AfterViewInit } from '@angular/core';
import { FormGroup, FormControl, Validators, ValidatorFn, FormBuilder } from '@angular/forms';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { CommaNumberValidator } from '../validator/commaNumberValidator';
import { debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';
import { FormControlWithError } from './FormControlWithError';
import { MyAwesomeRangeValidator } from './validators';
import { LocalSetting } from '../common/LocalSetting';

@Component({
    selector: 'app-justa-fire',
    templateUrl: './justa-fire.component.html',
    styleUrls: ['./justa-fire.component.css'],
    encapsulation: ViewEncapsulation.ShadowDom
})
export class JustaFireComponent implements OnInit, AfterViewInit {

    @Input() field: string;
    logging = false;
    color = 'red';
    targetElement: HTMLInputElement;
    errorMsg: string;

    myName = new FormControl('Justin');

    mySalary2 = new FormControlWithError('3,234,000.00');
    // put  on component directly help:
    //      IDE to do code completion suggesion even on html template
    //      Angular to do compiling checking
    //      Jasmine to do unit testing
    // if it is in myform, then those benefits are gone

    myJavaExperience = new FormControlWithError('30.5');
    rangeStart = new FormControlWithError('11');
    rangeEnd = new FormControlWithError('32');
    myform: FormGroup;
    // myform = new FormGroup({
    //     myName: this.myName,
    //     mySalary: this.mySalary,
    //     myJavaExperience: this.myJavaExperience,
    //     rangeStart: this.rangeStart,
    //     rangeEnd: this.rangeEnd
    // });

    constructor(private fb: FormBuilder) {

        this.logging = LocalSetting.getLoggin();

        this.myName.setValidators(Validators.required);
        this.mySalary2.setValidators([
            Validators.required,
            CommaNumberValidator()
        ]);
        this.myJavaExperience.setValidators([
            Validators.required,
            CommaNumberValidator()
        ]);
        this.rangeStart.setValidators([
            Validators.required,
            MyAwesomeRangeValidator
        ]);
        this.rangeEnd.setValidators([
            Validators.required,
            MyAwesomeRangeValidator
        ]);
        this.myform = this.fb.group({
            myName: this.myName,
            mySalary: this.mySalary2,
            myJavaExperience: this.myJavaExperience,
            rangeStart: this.rangeStart,
            rangeEnd: this.rangeEnd
        });

        this.checkField();
        this.hookObserver();

    }

    ngOnInit(): void {

    }

    ngAfterViewInit() {
        this.mySalary2.patchValue('2345.5');
    }

    private checkField(): boolean {
        if (!this.field) {
            this.errorMsg = 'Need to set field.';
            return false;
        }
        return true;
    }

    changeSalary(): void {
        this.mySalary2.patchValue('2345.5');
        // patch value always trigger the value change event even it is the same value as before
    }

    @HostListener('window:onJustaColorChange')
    onDataLoading() {
        if (this.logging) {
            console.log('onJustaColorChange: reset color...');
        }

        if (!this.checkTargetField()) {
            return;
        }

        this.color = this.targetElement.value;

        this.errorMsg = '';
    }

    private checkTargetField(): boolean {
        if (!this.checkField()) {
            return false;
        }

        this.targetElement = document.getElementById(this.field) as HTMLInputElement;
        if (!this.targetElement) {
            this.errorMsg = 'Didn\'t find target element: ' + this.field;
            return false;
        }
        return true;
    }

    private hookObserver(): void {

        this.myform.valueChanges.pipe(
            distinctUntilChanged()
        )
            .subscribe(term => {

                if (this.myform.valid) {
                    if (this.logging) {
                        console.log('valid data');
                    }
                } else {
                    if (this.logging) {
                        console.log('invalid data');
                    }
                }
            });
    }

}
